import React, { useEffect, useState } from 'react';

import { useIntl } from 'react-intl';

import Dialog from 'components/dialog';
import { CustomEventNames, EventTypes, useMParticleContext } from 'state/mParticle';
import { useNetworkContext } from 'state/network';

function ErrorNetwork() {
  const mParticle = useMParticleContext();
  const { formatMessage } = useIntl();
  const { hasNetworkError } = useNetworkContext();
  const [browsingOffline, setBrowsingOffline] = useState(false);
  const [hasOpened, setHasOpened] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!hasOpened && hasNetworkError && !browsingOffline) {
      mParticle.logEvent(CustomEventNames.NETWORK_ERROR, EventTypes.Other);
      setHasOpened(true);
      setIsOpen(true);
    }
  }, [browsingOffline, hasNetworkError, hasOpened, mParticle]);

  if (isOpen) {
    return (
      <Dialog
        showDialog
        modalAppearanceEventMessage="Network Error"
        testID="error-network-dialog"
        heading={formatMessage({ id: 'lostNetworkConnectivity' })}
        body={formatMessage({ id: 'checkNetworkSettings' })}
        accessibilityLabel={formatMessage({ id: 'lostNetworkConnectivity' })}
        showCloseButton
        onDismiss={() => {
          setBrowsingOffline(true);
          setIsOpen(false);
        }}
      />
    );
  }

  return null;
}

export default ErrorNetwork;
